import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { IConfigComponent, COrganization } from '@ts/ui-models';
import { generateGlobalColumns, IDataGridConfig } from '@ts/storybook';

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'organizations',
  aclId: 'taOrganization',
  entity: 'organization',
  fetchURL: '/api/organizations',
  crudURL: '/api/organization',
  mainClass: COrganization,
};

interface OrganizationsProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

const Organizations = (props: OrganizationsProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo(() => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });

    return [globalCells.id(), globalCells.name()];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //From grandpa
      inheritedProps={inheritedProps}
    />
  );
};

export default Organizations;
